import { defineMessages } from 'react-intl-next';

export const messages = defineMessages({
	tier: {
		id: 'search-page.compass.tier',
		defaultMessage: 'Tier {tier}',
		description:
			'Indicates how critical the component is to your business. The lower the tier, the higher the criticality.',
	},
	ownerName: {
		id: 'search-page.compass.owner-name',
		defaultMessage: 'Owned by {ownerName}',
		description: 'Indicates which team owns this component.',
	},
});
